import { SvgIcon, type SvgIconProps } from "@mui/material";

export const AccessDeniedImage = (props: SvgIconProps) => {
  return (
    <SvgIcon width="101.93" height="75" viewBox="0 0 101.93 75" {...props}>
      <defs>
        <linearGradient
          id="b"
          x1="50.96"
          y1="93.71"
          x2="50.96"
          y2="144.67"
          gradientTransform="translate(0 168.51) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".15" stopColor="#f5f5f5" stopOpacity=".3" />
          <stop offset=".38" stopColor="#f3f8fc" stopOpacity=".3" />
          <stop offset=".59" stopColor="#cee4f3" stopOpacity=".3" />
          <stop offset=".79" stopColor="#90c4e5" stopOpacity=".3" />
          <stop offset=".99" stopColor="#3b96d1" stopOpacity=".3" />
          <stop offset="1" stopColor="#3593d0" stopOpacity=".3" />
        </linearGradient>
      </defs>
      <path d="M0,74.8C0,46.65,22.82,23.84,50.96,23.84s50.96,22.82,50.96,50.96H0" fill="url(#b)" />
      <circle cx="50.92" cy="17.49" r="14" fill="#fff" />
      <path
        d="M74.65,55.34v7.19h-5.84v-7.19c0-6.75-5.5-12.25-12.25-12.25h-11.28c-6.75,0-12.25,5.5-12.25,12.25v7.19h-5.84v-7.19c0-4.04,1.33-7.89,3.83-11.1,3.46-4.43,8.67-6.99,14.25-6.99h11.28c3.51,0,6.93,1.04,9.87,2.97,5.13,3.36,8.21,9.01,8.21,15.11h0ZM33.45,17.49C33.45,7.84,41.29,0,50.93,0s17.49,7.82,17.49,17.46-7.84,17.49-17.49,17.49v.03c-9.64,0-17.49-7.84-17.49-17.49ZM61.81,21.51h-21.76c1.65,4.42,5.9,7.57,10.88,7.57s9.23-3.15,10.88-7.57h0ZM40.59,12.17h20.67c-1.93-3.75-5.83-6.33-10.33-6.33s-8.41,2.58-10.33,6.33Z"
        fill="#09344f"
      />
      <path
        d="M39.01,13.61c-1.78,0-3.23,1.45-3.23,3.23s1.45,3.23,3.23,3.23h23.81c1.78,0,3.23-1.45,3.23-3.23s-1.45-3.23-3.23-3.23h-23.81Z"
        fill="#fff"
      />
      <path
        d="M59.64,17.88c.14.14.14.37,0,.51-.07.07-.17.11-.25.11s-.19-.04-.25-.11l-1.03-1.03-1.03,1.03c-.07.07-.17.11-.25.11s-.19-.04-.25-.11c-.14-.14-.14-.37,0-.51l1.03-1.03-1.03-1.03c-.14-.14-.14-.37,0-.51s.37-.14.51,0l1.03,1.03,1.03-1.03c.14-.14.37-.14.51,0s.14.37,0,.51l-1.03,1.03,1.03,1.03h-.01ZM44.81,16.84l1.03-1.03c.14-.14.14-.37,0-.51s-.37-.14-.51,0l-1.03,1.03-1.03-1.03c-.14-.14-.37-.14-.51,0s-.14.37,0,.51l1.03,1.03-1.03,1.03c-.14.14-.14.37,0,.51.07.07.17.11.25.11s.19-.04.25-.11l1.03-1.03,1.03,1.03c.07.07.17.11.25.11s.19-.04.25-.11c.14-.14.14-.37,0-.51l-1.03-1.03h.01Z"
        fill="#09344f"
      />
    </SvgIcon>
  );
};
